function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import GoogleReCaptcha from "@common/components/GoogleReCaptcha";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import TextField from "@material-ui/core/TextField";
import BGCN from "bulgarian-control-numbers";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { openGdpr, openModal, signUp } from "@common/actions";
import { replaceWith, validateEmail } from "@common/services/helpers";
import { AUTH_PAGE_CONFIG, ERROR_SUBCODE_EXISTING_USER, ERROR_SUBCODE_PASSWORDS_DONT_MATCH, REGEX_PASSWORD, STATUS_CODE_SUCCESS, TERMS_AND_CONDITIONS } from "@config/constants";
import { isEmpty } from "lodash";
import PostSignUp from "./PostSignUp";
export var SignUp = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(SignUp, PureComponent);
    var _super = _create_super(SignUp);
    function SignUp(props) {
        _class_call_check(this, SignUp);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "toggleRecapcha", function(reCaptchaToken) {
            _this.setState({
                reCaptchaToken: reCaptchaToken
            });
        });
        _this.state = {
            acceptTerms: false,
            acceptTermsError: true,
            acceptTermsTouched: false,
            email: "",
            emailError: "",
            emailTouched: false,
            cf_marketing: false,
            password: "",
            passwordError: "",
            passwordTouched: false,
            subscriberNumber: "",
            subscriberNumberTouched: false,
            subscriberNumberError: "",
            ucn: "",
            ucnTouched: false,
            ucnError: "",
            ucnChecked: true,
            eik: "",
            eikTouched: false,
            eikError: "",
            eikChecked: false,
            privateData: false,
            privateDataError: true,
            privateDataTouched: false,
            registrationSuccess: false,
            repeatPassword: "",
            repeatPasswordError: "",
            repeatPasswordTouched: false,
            serverError: ""
        };
        _this.onChange = _this.onChange.bind(_assert_this_initialized(_this));
        _this.openGDPRPopup = _this.openGDPRPopup.bind(_assert_this_initialized(_this));
        _this.signUp = _this.signUp.bind(_assert_this_initialized(_this));
        _this.openTermsAndConditions = _this.openTermsAndConditions.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(SignUp, [
        {
            /**
     *  Validates a password and sets the appropriate
     *  error in the state.
     * @param {string} key - `password` or `repeatPassword`
     */ key: "validatePassword",
            value: function validatePassword(key) {
                var validityError = REGEX_PASSWORD.test(this.state[key]) ? "" : this.props.i18n.authentication.enterPassword;
                var matchError = this.state.password === this.state.repeatPassword ? "" : this.props.i18n.authentication.passwordsDontMatch;
                this.setState(_define_property({}, "".concat(key, "Error"), validityError || matchError));
            }
        },
        {
            /**
     * Validates the different checkboxes.
     * Uses their `value` property to
     * identify the right checkbox.
     * @param {string} value
     */ key: "validateCheckbox",
            value: function validateCheckbox(value) {
                this.setState(function(prevState) {
                    return _define_property({}, "".concat(value, "Error"), !prevState[value]);
                });
            }
        },
        {
            /**
     * Validates subscriber number input
     * @param {string} value
     */ key: "validateSubscriberNumber",
            value: function validateSubscriberNumber(value) {
                var errorText = typeof value === "string" && value.length > 0 && value.length <= 3 ? this.props.i18n.authentication.enterValidSN : "";
                this.setState({
                    subscriberNumberError: errorText
                });
            }
        },
        {
            /**
     * Validates UCN value
     * @param value
     */ key: "validateUCN",
            value: function validateUCN(value) {
                var errorText = "";
                var egn = {};
                try {
                    egn = BGCN.egn(value);
                } catch (e) {}
                if (!egn.isValid) {
                    errorText = this.props.i18n.authentication.enterValidUCN;
                }
                this.setState({
                    ucnError: errorText
                });
            }
        },
        {
            key: "validateEIK",
            value: function validateEIK(value) {
                var errorText = "";
                var bulstat = {};
                try {
                    bulstat = BGCN.bulstat(value);
                } catch (e) {}
                if (!bulstat.isValid) {
                    errorText = this.props.i18n.authentication.enterValidEIK;
                }
                this.setState({
                    eikError: errorText
                });
            }
        },
        {
            /**
     * Mark all inputs that use validation
     * as touched, which will trigger
     * the validation (see `componentDidUpdate`).
     */ key: "markInputsAsTouched",
            value: function markInputsAsTouched() {
                this.setState({
                    emailTouched: true,
                    passwordTouched: true,
                    repeatPasswordTouched: true,
                    acceptTermsTouched: true,
                    privateDataTouched: true
                });
            }
        },
        {
            key: "signUp",
            value: /**
     * Sends user's credentials to the backend
     * if there are no email or password errors.
     * If server responds with specific error,
     * it sets `serverError` and marks text
     * inputs as touched.
     * @returns {Promise<void>}
     */ function signUp(event) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_state, acceptTermsError, email, emailError, emailTouched, cf_marketing, password, passwordError, passwordTouched, privateData, privateDataError, repeatPassword, repeatPasswordError, repeatPasswordTouched, reCaptchaToken, subscriberNumber, subscriberNumberError, ucn, ucnError, history, errors, hasErrorInUserData, textInputNotTouched, trimmedEmail, signUpData, response, error, hasSpecificServerError, errorText;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                event.preventDefault();
                                _this_state = _this.state, acceptTermsError = _this_state.acceptTermsError, email = _this_state.email, emailError = _this_state.emailError, emailTouched = _this_state.emailTouched, cf_marketing = _this_state.cf_marketing, password = _this_state.password, passwordError = _this_state.passwordError, passwordTouched = _this_state.passwordTouched, privateData = _this_state.privateData, privateDataError = _this_state.privateDataError, repeatPassword = _this_state.repeatPassword, repeatPasswordError = _this_state.repeatPasswordError, repeatPasswordTouched = _this_state.repeatPasswordTouched, reCaptchaToken = _this_state.reCaptchaToken, subscriberNumber = _this_state.subscriberNumber, subscriberNumberError = _this_state.subscriberNumberError, ucn = _this_state.ucn, ucnError = _this_state.ucnError;
                                history = _this.props.history;
                                errors = _this.props.i18n.errors;
                                hasErrorInUserData = acceptTermsError || emailError || passwordError || privateDataError || repeatPasswordError || subscriberNumberError || ucnError;
                                textInputNotTouched = !emailTouched || !passwordTouched || !repeatPasswordTouched;
                                if (hasErrorInUserData || textInputNotTouched) {
                                    return [
                                        2,
                                        _this.markInputsAsTouched()
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                trimmedEmail = email.replace(/\s/g, "");
                                signUpData = {
                                    email: trimmedEmail,
                                    cf_marketing: cf_marketing,
                                    password: password,
                                    privateData: privateData,
                                    repeatPassword: repeatPassword,
                                    ucn: ucn,
                                    "g-recaptcha-response": reCaptchaToken
                                };
                                return [
                                    4,
                                    _this.props.signUp(signUpData)
                                ];
                            case 2:
                                response = _state.sent();
                                // After successful registration, change state
                                // so the 'PostSignUp' component can be rendered.
                                if (response.status === STATUS_CODE_SUCCESS) {
                                    _this.setState({
                                        registrationSuccess: true
                                    });
                                    history.push("".concat(history.location.pathname, "?success"));
                                    dataLayer.push({
                                        event: "register",
                                        pageCategory: "signup"
                                    });
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                hasSpecificServerError = error && error.subcode;
                                if (hasSpecificServerError) {
                                    errorText = errors["error".concat(error.subcode)];
                                    switch(error.subcode){
                                        case ERROR_SUBCODE_EXISTING_USER:
                                            _this.setState({
                                                serverError: errorText
                                            });
                                            break;
                                        case ERROR_SUBCODE_PASSWORDS_DONT_MATCH:
                                            _this.setState({
                                                passwordError: errorText,
                                                repeatPasswordError: errorText
                                            });
                                            break;
                                        default:
                                            break;
                                    }
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Sets the new state for a given input.
     * @param {Object} event
     */ key: "onChange",
            value: function onChange(event) {
                var _event_target = event.target, checked = _event_target.checked, name = _event_target.name, type = _event_target.type, value = _event_target.value;
                var key = type === "checkbox" ? value : name;
                var newValue = type === "checkbox" ? checked : value;
                var newStateObject = _define_property({}, key, newValue);
                if (key === "subscriberNumber" && newValue === "") {
                    newStateObject.ucn = "";
                    newStateObject.ucnError = "";
                    newStateObject.ucnTouched = false;
                    newStateObject.eik = "";
                    newStateObject.eikError = "";
                    newStateObject.eikTouched = false;
                }
                this.setState(newStateObject);
            }
        },
        {
            /**
     * Opens the gdpr popup.
     */ key: "openGDPRPopup",
            value: function openGDPRPopup() {
                this.props.openGdpr("email");
            }
        },
        {
            /**
     * Opens a popup
     */ key: "openTermsAndConditions",
            value: function openTermsAndConditions() {
                var i18n = this.props.i18n;
                var modalProps = {
                    title: i18n.termsAndConditions.title,
                    text: i18n.termsAndConditions.text
                };
                this.props.openModal(TERMS_AND_CONDITIONS, modalProps);
            }
        },
        {
            /**
     * Renders the navigation links.
     * @returns {*}
     */ key: "renderNavigation",
            value: function renderNavigation() {
                var i18n = this.props.i18n;
                var _i18n_authentication = i18n.authentication, signIn = _i18n_authentication.signIn, _$signUp = _i18n_authentication.signUp;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "secondary-navigation two-links",
                    children: [
                        /*#__PURE__*/ _jsx(NavLink, {
                            to: "/login",
                            activeClassName: "selected",
                            children: signIn
                        }),
                        /*#__PURE__*/ _jsx(NavLink, {
                            to: "/register",
                            activeClassName: "selected",
                            children: _$signUp
                        })
                    ]
                });
            }
        },
        {
            /**
     * Renders the inputs.
     * @returns {*}
     */ key: "renderInputs",
            value: function renderInputs() {
                var _this = this;
                var _this_state = this.state, acceptTerms = _this_state.acceptTerms, acceptTermsError = _this_state.acceptTermsError, acceptTermsTouched = _this_state.acceptTermsTouched, privateData = _this_state.privateData, privateDataError = _this_state.privateDataError, privateDataTouched = _this_state.privateDataTouched, email = _this_state.email, emailError = _this_state.emailError, password = _this_state.password, passwordError = _this_state.passwordError, repeatPassword = _this_state.repeatPassword, repeatPasswordError = _this_state.repeatPasswordError, serverError = _this_state.serverError, cf_marketing = _this_state.cf_marketing, subscriberNumber = _this_state.subscriberNumber, subscriberNumberError = _this_state.subscriberNumberError, ucn = _this_state.ucn, ucnError = _this_state.ucnError, ucnChecked = _this_state.ucnChecked, eik = _this_state.eik, eikError = _this_state.eikError, eikChecked = _this_state.eikChecked;
                var i18n = this.props.i18n;
                // Make the 'terms' part of the translated label 'active' (a button)
                var agreeTerms = '<button type="button"\n                                    id="terms-button"\n                                    class="translation-active">'.concat(i18n.authentication.theTerms, "</button>");
                var agreeTermsLabel = /*#__PURE__*/ _jsx("span", {
                    dangerouslySetInnerHTML: {
                        __html: replaceWith(i18n.authentication.agreeTerms, agreeTerms)
                    }
                });
                // Make the 'to provide my email' part of the translated label 'active' (a button)
                var provideMyEmail = '<button type="button"\n                                        id="gdpr-button"\n                                        class="translation-active">'.concat(i18n.authentication.provideMyEmail, "</button>");
                var provideMyEmailLabel = /*#__PURE__*/ _jsx("span", {
                    dangerouslySetInnerHTML: {
                        __html: replaceWith(i18n.authentication.agreeTo, provideMyEmail)
                    }
                });
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(TextField, {
                            className: "ux-text-field-root",
                            autoComplete: "off",
                            InputProps: {
                                onBlur: function() {
                                    return _this.setState({
                                        emailTouched: true
                                    });
                                },
                                className: "ux-input",
                                classes: {
                                    error: "ux-input-error"
                                }
                            },
                            InputLabelProps: {
                                classes: {
                                    root: "ux-input-label"
                                }
                            },
                            FormHelperTextProps: {
                                error: true,
                                classes: {
                                    root: "ux-form-helper-text"
                                }
                            },
                            error: emailError !== "" || serverError !== "",
                            helperText: serverError || emailError,
                            id: "email",
                            type: "text",
                            name: "email",
                            value: email,
                            label: i18n.authentication.email,
                            onChange: this.onChange,
                            margin: "none"
                        }),
                        /*#__PURE__*/ _jsx(TextField, {
                            className: "ux-text-field-root",
                            InputProps: {
                                onBlur: function() {
                                    return _this.setState({
                                        passwordTouched: true
                                    });
                                },
                                className: "ux-input password",
                                classes: {
                                    error: "ux-input-error"
                                }
                            },
                            InputLabelProps: {
                                classes: {
                                    root: "ux-input-label"
                                }
                            },
                            FormHelperTextProps: {
                                error: true,
                                classes: {
                                    root: "ux-form-helper-text"
                                }
                            },
                            error: passwordError !== "",
                            helperText: passwordError,
                            id: "password",
                            type: "password",
                            name: "password",
                            value: password,
                            label: i18n.authentication.password,
                            onChange: this.onChange,
                            margin: "none"
                        }),
                        /*#__PURE__*/ _jsx(TextField, {
                            className: "ux-text-field-root",
                            InputProps: {
                                onBlur: function() {
                                    return _this.setState({
                                        repeatPasswordTouched: true
                                    });
                                },
                                className: "ux-input password",
                                classes: {
                                    error: "ux-input-error"
                                }
                            },
                            InputLabelProps: {
                                classes: {
                                    root: "ux-input-label"
                                }
                            },
                            FormHelperTextProps: {
                                error: true,
                                classes: {
                                    root: "ux-form-helper-text"
                                }
                            },
                            error: repeatPasswordError !== "",
                            helperText: repeatPasswordError,
                            id: "repeat-password",
                            type: "password",
                            name: "repeatPassword",
                            value: repeatPassword,
                            label: i18n.authentication.repeatPassword,
                            onChange: this.onChange,
                            margin: "none"
                        }),
                        AUTH_PAGE_CONFIG.SIGN_UP_SUBSCRIBER_NUM_ENABLED && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(TextField, {
                                    className: "ux-text-field-root",
                                    autoComplete: "off",
                                    InputProps: {
                                        onBlur: function() {
                                            return _this.setState({
                                                subscriberNumberTouched: true
                                            });
                                        },
                                        className: "ux-input",
                                        classes: {
                                            error: "ux-input-error"
                                        }
                                    },
                                    InputLabelProps: {
                                        classes: {
                                            root: "ux-input-label"
                                        }
                                    },
                                    FormHelperTextProps: {
                                        error: true,
                                        classes: {
                                            root: "ux-form-helper-text"
                                        }
                                    },
                                    error: subscriberNumberError !== "" || serverError !== "",
                                    helperText: serverError || subscriberNumberError,
                                    id: "subscriberNumber",
                                    type: "text",
                                    name: "subscriberNumber",
                                    value: subscriberNumber,
                                    label: i18n.authentication.subscriberNumber,
                                    onChange: this.onChange,
                                    margin: "none"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "MuiFormHelperText-root-49 subscriber-number-helper-text ".concat(serverError || subscriberNumberError ? "with-error" : null),
                                    children: i18n.authentication.subscriberNumberHelperText
                                })
                            ]
                        }),
                        subscriberNumber !== "" && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "radio-holder",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "radio-group",
                                            children: [
                                                /*#__PURE__*/ _jsx(Radio, {
                                                    checked: this.state.ucnChecked,
                                                    classes: {
                                                        checked: "ux-checked"
                                                    },
                                                    onClick: function() {
                                                        return _this.setState({
                                                            ucnChecked: !ucnChecked,
                                                            eikChecked: !eikChecked
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx("p", {
                                                    children: "Частно лице"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "radio-group",
                                            children: [
                                                /*#__PURE__*/ _jsx(Radio, {
                                                    checked: this.state.eikChecked,
                                                    classes: {
                                                        checked: "ux-checked"
                                                    },
                                                    onClick: function() {
                                                        return _this.setState({
                                                            eikChecked: !eikChecked,
                                                            ucnChecked: !ucnChecked
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx("p", {
                                                    children: "Фирма"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                ucnChecked && /*#__PURE__*/ _jsx(TextField, {
                                    className: "ux-text-field-root",
                                    autoComplete: "off",
                                    InputProps: {
                                        onBlur: function() {
                                            return _this.setState({
                                                ucnTouched: true,
                                                eikTouched: false
                                            });
                                        },
                                        className: "ux-input",
                                        classes: {
                                            error: "ux-input-error"
                                        }
                                    },
                                    InputLabelProps: {
                                        classes: {
                                            root: "ux-input-label"
                                        }
                                    },
                                    FormHelperTextProps: {
                                        error: true,
                                        classes: {
                                            root: "ux-form-helper-text"
                                        }
                                    },
                                    error: ucnError !== "" || serverError !== "",
                                    helperText: serverError || ucnError,
                                    id: "ucn",
                                    type: "text",
                                    name: "ucn",
                                    value: ucn,
                                    label: i18n.authentication.ucn,
                                    onChange: this.onChange,
                                    margin: "none"
                                }),
                                eikChecked && /*#__PURE__*/ _jsx(TextField, {
                                    className: "ux-text-field-root",
                                    autoComplete: "off",
                                    InputProps: {
                                        onBlur: function() {
                                            return _this.setState({
                                                eikTouched: true,
                                                ucnTouched: false
                                            });
                                        },
                                        className: "ux-input",
                                        classes: {
                                            error: "ux-input-error"
                                        }
                                    },
                                    InputLabelProps: {
                                        classes: {
                                            root: "ux-input-label"
                                        }
                                    },
                                    FormHelperTextProps: {
                                        error: true,
                                        classes: {
                                            root: "ux-form-helper-text"
                                        }
                                    },
                                    error: eikError !== "" || serverError !== "",
                                    helperText: serverError || eikError,
                                    id: "eik",
                                    type: "text",
                                    name: "eik",
                                    value: eik,
                                    label: i18n.authentication.eik,
                                    onChange: this.onChange,
                                    margin: "none"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(FormControlLabel, {
                            control: /*#__PURE__*/ _jsx(Checkbox, {
                                classes: {
                                    checked: "ux-checked"
                                },
                                id: "cf_marketing",
                                type: "checkbox",
                                checked: cf_marketing,
                                onChange: this.onChange,
                                value: "cf_marketing"
                            }),
                            label: i18n.authentication.wantNotifications,
                            classes: {
                                root: "ux-checkbox-label-root",
                                label: "ux-checkbox-label tiny-font"
                            }
                        }),
                        /*#__PURE__*/ _jsx(FormControlLabel, {
                            control: /*#__PURE__*/ _jsx(Checkbox, {
                                classes: {
                                    checked: "ux-checked"
                                },
                                id: "accept-terms",
                                type: "checkbox",
                                checked: acceptTerms,
                                onChange: this.onChange,
                                value: "acceptTerms",
                                inputProps: {
                                    onClick: function() {
                                        return _this.setState({
                                            acceptTermsTouched: true
                                        });
                                    }
                                }
                            }),
                            label: agreeTermsLabel,
                            classes: {
                                root: "ux-checkbox-label-root",
                                label: "ux-checkbox-label tiny-font".concat(acceptTermsError && acceptTermsTouched ? " error" : "")
                            }
                        }),
                        /*#__PURE__*/ _jsx(FormControlLabel, {
                            control: /*#__PURE__*/ _jsx(Checkbox, {
                                classes: {
                                    checked: "ux-checked"
                                },
                                id: "private-data",
                                type: "checkbox",
                                checked: privateData,
                                onChange: this.onChange,
                                value: "privateData",
                                inputProps: {
                                    onClick: function() {
                                        return _this.setState({
                                            privateDataTouched: true
                                        });
                                    }
                                }
                            }),
                            label: provideMyEmailLabel,
                            classes: {
                                root: "ux-checkbox-label-root",
                                label: "ux-checkbox-label tiny-font".concat(privateDataError && privateDataTouched ? " error" : "")
                            }
                        })
                    ]
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var termsButton = document.getElementById("terms-button");
                var gdprButton = document.getElementById("gdpr-button");
                termsButton === null || termsButton === void 0 ? void 0 : termsButton.addEventListener("click", this.openTermsAndConditions);
                gdprButton === null || gdprButton === void 0 ? void 0 : gdprButton.addEventListener("click", this.openGDPRPopup);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var termsButton = document.getElementById("terms-button");
                var gdprButton = document.getElementById("gdpr-button");
                termsButton && termsButton.removeEventListener("click", this.openTermsAndConditions);
                gdprButton && gdprButton.removeEventListener("click", this.openGDPRPopup);
            }
        },
        {
            key: "render",
            value: function render() {
                var registrationSuccess = this.state.registrationSuccess;
                var i18n = this.props.i18n;
                var template = null;
                if (registrationSuccess) {
                    template = /*#__PURE__*/ _jsx(PostSignUp, {
                        i18n: i18n
                    });
                } else {
                    template = /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            this.renderNavigation(),
                            /*#__PURE__*/ _jsx("div", {
                                className: "authentication-link-description margin-top-tiny margin-bottom-small",
                                children: i18n.authentication.fastAndFree
                            }),
                            /*#__PURE__*/ _jsxs("form", {
                                onSubmit: this.signUp,
                                children: [
                                    this.renderInputs(),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "recapcha",
                                        children: /*#__PURE__*/ _jsx(GoogleReCaptcha, {
                                            action: "sign_in",
                                            onChange: this.toggleRecapcha
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Button, {
                                        classes: {
                                            label: "ux-button-label"
                                        },
                                        className: "button raised full-width margin-top-tiny",
                                        type: "submit",
                                        children: i18n.authentication.signMeUp
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "sign-in-link margin-top-small",
                                children: /*#__PURE__*/ _jsxs(Link, {
                                    to: "/login",
                                    children: [
                                        i18n.authentication.signExistingEmail,
                                        "?"
                                    ]
                                })
                            }),
                            !isEmpty(AUTH_PAGE_CONFIG === null || AUTH_PAGE_CONFIG === void 0 ? void 0 : AUTH_PAGE_CONFIG.FORM_LOGO_URL) && /*#__PURE__*/ _jsx("div", {
                                className: "authentication-logo",
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: AUTH_PAGE_CONFIG.FORM_LOGO_URL,
                                    alt: AUTH_PAGE_CONFIG.FORM_LOGO_ALT
                                })
                            })
                        ]
                    });
                }
                return /*#__PURE__*/ _jsx("div", {
                    className: "sign-up-component".concat(registrationSuccess ? " success" : ""),
                    children: template
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState, prevContext) {
                var _this = this;
                var emailHasChangedOrEmpty = prevState.email !== this.state.email || this.state.email === "";
                var emailWasTouched = !prevState.emailTouched && this.state.emailTouched;
                var noServerError = this.state.serverError === "";
                if (emailHasChangedOrEmpty && this.state.emailTouched || emailWasTouched && noServerError) {
                    validateEmail(this.state.email, function(isValid) {
                        var emailError = isValid ? "" : _this.props.i18n.authentication.enterValidMail;
                        _this.setState({
                            emailError: emailError,
                            serverError: ""
                        });
                    });
                }
                if (this.state.passwordTouched) {
                    this.validatePassword("password");
                }
                if (this.state.repeatPasswordTouched) {
                    this.validatePassword("repeatPassword");
                }
                if (this.state.subscriberNumberTouched) {
                    this.validateSubscriberNumber(this.state.subscriberNumber);
                }
                if (this.state.ucnTouched) {
                    this.validateUCN(this.state.ucn);
                }
                if (this.state.eikTouched) {
                    this.validateEIK(this.state.eik);
                }
                if (this.state.acceptTermsTouched) {
                    this.validateCheckbox("acceptTerms");
                }
                if (this.state.privateDataTouched) {
                    this.validateCheckbox("privateData");
                }
            }
        }
    ]);
    return SignUp;
}(PureComponent);
export default withRouter(connect(null, {
    signUp: signUp,
    openGdpr: openGdpr,
    openModal: openModal
})(SignUp));
